export default [
  'eudora',
  'natura',
  'boticario',
  'algar',
  'bradesco',
  'credsystem',
  'viacerta',
]
